import { getLocale } from "../runtime";

const sv_grcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Greece`
};

const grcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_grcountryenglish(inputs)
	return "grCountryEnglish";
};

export { grcountryenglish as "grCountryEnglish" };